import styled from 'styled-components';
import * as Grid from 'components/Grid';

export const Section = styled.section`
  display: flex;
  align-items: center;
  min-height: 480px;
  width: 100%;
  padding: 40px 0;
  background-image: linear-gradient(177deg, #ffffff 8%, #f3f5f7 78%);
`;

export const Container = styled(Grid.Container)`
  width: 100%;
  padding: 0 !important;
`;
